module.exports = __webpack_public_path__ + "img/twitch_white.62a2979e.svg";